import { usePermissions } from "ra-core";

import { principalCacheKey } from "./local/principal";

/** Actions the BFF may allow (infra/lambda/bff/permissions.mjs, W9 F4). */
export type CrmPermission =
  | "merge_contacts"
  | "create_records"
  | "move_stage"
  | "edit_details"
  | "notes_tasks"
  | "links";

/**
 * Whether the signed-in user may take `permission`, from /me. False while
 * loading, so a control never flashes on for a user who cannot use it; the
 * BFF refuses the write regardless.
 */
export function usePermission(permission: CrmPermission): boolean {
  // Keyed by who is signed in, so a new sign-in (or stub role) fetches its
  // own permissions instead of reusing an earlier, possibly empty, answer.
  const { permissions } = usePermissions<string[]>({
    principal: principalCacheKey(),
  });
  return Array.isArray(permissions) && permissions.includes(permission);
}
